const type = 'SET_LIMITS';

const setLimits = (data) => ({
  type,
  data,
});

export { type };
export default setLimits;
